import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { FormularioOrtodontia } from '../base/vo/formulario-ortodontia';

@Component({
    selector: 'app-itens-tratamento',
    templateUrl: './itens-tratamento.component.html',
    styleUrls: ['./itens-tratamento.component.css']
})
export class ItensTratamentoComponent implements OnInit {

    @Input() ortodontia: FormularioOrtodontia;
    @Output() ortodontiaEvent = new EventEmitter<FormularioOrtodontia>();
    @ViewChild('itensPainel') itensPainel: ElementRef;
    public visible: boolean = false;

    @Input() itensTratamentoForm: FormGroup;

    constructor() { }

    ngOnInit() {
    }

    public abrirItens(){
        this.visible = true;
    }

    private fecharItens(e){
        if (e.target == this.itensPainel.nativeElement) {
            this.visible = false;
        }
    }
    
    private fecharItensBotao(){
    	this.visible = false;
    }

    private setItens(){
        this.ortodontiaEvent.emit(this.ortodontia);
    }

    private setTexto(){
        this.ortodontiaEvent.emit(this.ortodontia);
    }

    private checkEvent(nomeCheck: string, nomeInput: string, form: FormGroup){
        setTimeout(() => {
            this.setItens();
            this.limparInput(nomeInput);
            this.addOuRemoverObrigatoriedade(nomeCheck, nomeInput, form);
        });
    }

    private limparInput(nomeInput) {
        this.ortodontia[nomeInput] = '';
    }

    private addOuRemoverObrigatoriedade(nomeCheck, nomeInput, form){
        form.get(nomeInput).setValidators([Validators.required]);
        if(!this.ortodontia[nomeCheck]) {
            form.get(nomeInput).markAsUntouched();
            form.get(nomeInput).disable();
        } else {
            form.get(nomeInput).enable();
            form.get(nomeInput).markAsTouched();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/itens-tratamento/itens-tratamento.component.ts